export default __webpack_public_path__ + "static/accounting-system-454cff61e41b80dfbbfdcb84b0c53ac6.jpeg";